import React, { useEffect, useState } from 'react';
import { GetConsentByIdResponse } from '../../../../../Models/Response/Consent/GetConsentById';
import { getConsentByConsentId } from '../../../../../Services/ConsentServices/ConsentService';
import CommonConsentDetails from '../../CommonConsentDetails';
import '../index.css';

interface IRevokedConsentProps {
  consentUniqueId: string;
  type: string;
  createdOrUpdatedOn: string;
}

const RevokedConsent: React.FC<IRevokedConsentProps> = ({
  consentUniqueId,
  type,
  createdOrUpdatedOn,
}) => {
  const [consentDetailsById, setConsentDetailsById] = useState({
    Customer: { id: '' },
    DataConsumer: { dataConsumerType: '', id: '' },
    DataFilter: [{ type: '', operator: '', value: '' }],
    DataLife: { unit: '', value: 0 },
    FIDataRange: { from: '', to: '' },
    Frequency: { unit: '', value: 0 },
    Purpose: { category: { type: '' }, code: '', refUri: '', text: '' },
    consentExpiry: '',
    consentMode: '',
    consentStart: '',
    consentTypes: [''],
    fetchType: '',
    fiTypes: [''],
    DataProvider: { id: '', type: '' },
    Accounts: [
      {
        fiType: '',
        fipId: '',
        fipName: '',
        accType: '',
        linkRefNumber: '',
        maskedAccNumber: '',
      },
    ],
  });

  useEffect(() => {
    getConsentByConsentId(consentUniqueId)
      .then((res) => res.data)
      .then((res: GetConsentByIdResponse) => setConsentDetailsById(res));
  }, [consentUniqueId]);

  return (
    <>
      <CommonConsentDetails
        createdOrUpdatedOn={createdOrUpdatedOn}
        type={type}
        consentByUniqueIdDetails={consentDetailsById}
        account={consentDetailsById.Accounts}
      />
    </>
  );
};

export default RevokedConsent;
